import React, { useEffect } from "react"
import { graphql, useStaticQuery } from "gatsby"
import { documentToHtmlString } from "@contentful/rich-text-html-renderer"

export default function Banner({ hidden, toggleAnnouncement }) {

	// I am not sure if it's possible to enforce in Contenful that only banner is designated as active
	// at a time, so I am just grabbing the most recently created site banner that is marked active.
  let data = useStaticQuery(graphql`
		query BannerQuery {
		  allContentfulSiteBanner(filter:{isActive:{ eq:true}}, sort:{createdAt:DESC}) {
		    nodes {
		      title
		      timeoutLengthMs
		      content {
		      	raw
		      }
		      ctaText
		      ctaUrl
		      ctaStyle
		      bannerBackgroundColor
		      bannerTextColor
		      ctaBackgroundColor
		      ctaTextColor
		      urlBlacklist
		    }
		  }
		}
  `)?.allContentfulSiteBanner?.nodes?.at(0)

  useEffect(() => {
		const hideAnnouncement = (event) => {
  		toggleAnnouncement(true)
  	}

  	const hideOnCurrentPage = (urlBlacklist) => urlBlacklist?.includes(window.location.href)

  	if (data && !hideOnCurrentPage(data.urlBlacklist)) {
  		toggleAnnouncement(false)
  		if (data.timeoutLengthMs) {
		  	setTimeout(hideAnnouncement, data.timeoutLengthMs)
  		}
  	}
  }, [])

  const extractColor = (color) => {
  	return color ? color.split(" ").slice(1).join("-") : "";
  }

  return (
  	data ? (
     	<div className={`announcement-link -cms -background-${extractColor(data.bannerBackgroundColor)} -text-${extractColor(data.bannerTextColor)} ${hidden ? '-hidden' : ''}`}>
	        <div
		        className="announcement-headline"
	          dangerouslySetInnerHTML={{
	            __html: documentToHtmlString(JSON.parse(data.content.raw)),
	          }}
	          style={{textAlign: 'center'}}
	        ></div>
	        {
	        	data.ctaUrl && data.ctaText && (
							<a className={`announcement-cta -text-${extractColor(data.ctaTextColor)} -${data.ctaStyle} -background-${extractColor(data.ctaBackgroundColor)}`} href={data.ctaUrl}>
			        	{data.ctaText}
			        </a>
	        	)
	        }
  		</div>
  	) : null
  )
}
